import CTAButton from "components/CTAButton";
import { useEnterWithEmail } from "hooks/useEnterWithEmail";
import { validate as isEmail } from "isemail";
import React, { ChangeEvent, SyntheticEvent, useState } from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";
import googleTagManagerId from "../../constants/googleTagManagerId";

const Wrapper = styled.div``;

const Form = styled.form`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  max-width: 454px;
  border-radius: 24px;
  padding: 4px;
  background: ${({ theme }) => theme.inputBackground};
  color: ${({ theme }) => theme.inputText};
  box-shadow: 0 4px 25px 0 ${({ theme }) => theme.palette.black15},
    inset 0 4px 20px 0 rgba(97, 97, 97, 0.06);

  &::placeholder {
    color: ${({ theme }) => theme.inputPlaceholder};
  }

  ${CTAButton} {
    font-size: 13px;
    width: 80px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    ${mediaMin.xs`
      width: 120px;
      font-size: 15px;
    `};
  }

  ${mediaMin.xs`
    height: 56px;
    border-radius: 28px;
  `};

  ${mediaMin.md`
    height: 62px;
    border-radius: 31px;
    padding: 6px;
  `};

  ${mediaMin.lg`
    height: 64px;
  `};
`;

const Input = styled.input`
  flex: 1;
  min-width: 120px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.inputText};
  padding-left: 12px;

  &::placeholder {
    color: ${({ theme }) => theme.inputPlaceholder};
  }

  ${mediaMin.xs`
    padding-left: 24px;
  `}

  ${mediaMin.lg`
    width: auto;
    flex: 1;
    padding-left: 32px;
    padding-bottom: 4px;
  `}
`;

const InvalidMessage = styled.span`
  position: absolute;
  bottom: -24px;
  font-size: 12px;
`;

export default function SignInInput() {
  const [inputValue, setInputValue] = useState("");
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);
  const { handleSignin } = useEnterWithEmail(inputValue);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    setIsInvalidEmail(false);
  };

  const handleSubmitSignIn = async (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isEmail(inputValue)) {
      await handleSignin();
    } else {
      setIsInvalidEmail(true);
    }
  };

  return (
    <Wrapper>
      <Form noValidate onSubmit={handleSubmitSignIn}>
        <Input
          type="email"
          value={inputValue}
          onChange={handleChange}
          placeholder="Enter your email"
          data-gtm-id={googleTagManagerId.LandingSignIn_EmailAddress_Input}
        />
        {isInvalidEmail && (
          <InvalidMessage>Please check your email.</InvalidMessage>
        )}
        <CTAButton data-gtm-id={googleTagManagerId.LandingSignIn_SignIn_Button}>
          Sign in
        </CTAButton>
      </Form>
    </Wrapper>
  );
}
